import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-6_yongche_no",
  "use": "icon-6_yongche_no-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-6_yongche_no\">\n<path d=\"M11.8897 13.1971C12.2504 11.8986 13.4326 11 14.7803 11H24.934C26.2391 11 27.3946 11.8438 27.7917 13.0871L30 20H10L11.8897 13.1971Z\" fill=\"#D3E3F7\" />\n<rect x=\"10\" y=\"27\" width=\"4\" height=\"4\" rx=\"2\" fill=\"#D3E3F7\" />\n<rect x=\"26\" y=\"27\" width=\"4\" height=\"4\" rx=\"2\" fill=\"#D3E3F7\" />\n<path d=\"M7.64618 20.5947C7.84888 19.1082 9.11846 18 10.6187 18H29.3813C30.8815 18 32.1511 19.1082 32.3538 20.5947L33.0356 25.5947C33.2813 27.3959 31.8811 29 30.0631 29H9.93686C8.1189 29 6.71873 27.3959 6.96436 25.5947L7.64618 20.5947Z\" fill=\"#BBD0EA\" />\n<path d=\"M15 23H12\" stroke=\"white\" stroke-opacity=\"0.9\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<path d=\"M28 23H25\" stroke=\"white\" stroke-opacity=\"0.9\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/6_yongche_no.svg
// module id = yl/1
// module chunks = 45